// extracted by mini-css-extract-plugin
export default {"NonFieldErrors":"NonFieldErrors_NonFieldErrors__qys-6"};